import { connect } from 'react-redux';

import {
  onSubmitCreateTeamSuccess,
  submitCreateTeam,
  TeamType,
} from 'app/gamma/src/modules/state/models/teams';
import { removeOverlay } from 'app/gamma/src/modules/state/ui/overlay';
import { State } from 'app/gamma/src/modules/types';
import { getTeamType } from 'app/gamma/src/selectors/overlays';
import { OrganizationsResponse } from 'app/gamma/src/types/responses';
import { Dispatch } from 'app/gamma/src/types';
import {
  CreateTeamUnconnected,
  StateProps,
  DispatchProps,
} from './create-team-unconnected';
import { featureFlagClient } from '@trello/feature-flag-client';
import { getMe } from '../../selectors/members';
import { isDesktop } from '@trello/browser';

const mapStateToProps = (state: State): StateProps => ({
  emailAddress: getMe(state)!.email,
  isDesktop: isDesktop(),
  freeTeamLimitWarning: featureFlagClient.get(
    'fv.domain-level-free-team-warning',
    false,
  ),
  freeTeamLimitRestriction: featureFlagClient.get(
    'fv.domain-level-free-team-restricted',
    false,
  ),
  teamType: getTeamType(state),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return {
    onClose() {
      dispatch(removeOverlay());
    },

    submitTeamCreation: ({
      type,
      displayName,
      teamType,
      desc,
    }: {
      type: TeamType;
      displayName: string;
      teamType?: string;
      desc?: string;
    }): Promise<OrganizationsResponse | void> => {
      return dispatch(
        submitCreateTeam({
          type,
          displayName,
          teamType,
          desc,
        }),
      );
    },

    onCreateTeamSuccess: (type: TeamType, team: OrganizationsResponse) => {
      return dispatch(onSubmitCreateTeamSuccess({ type, team }));
    },
  };
};

export const CreateTeam = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateTeamUnconnected);
